import "./Services.css";
const services = [
  {
    id: "01",
    img: "",
    title: "Creative Design",
    desc: "In today’s digital world, your website is the first interaction consumers have with your business. That's why almost 95 percent of a user’s first impression relates to web design",
  },
  {
    id: "02",
    title: "Web Development",
    desc: "Web development is the building and maintenance of websites; it's the work that happens behind the scenes to make a website look great, work fast and .",
  },
  // perform well with a seamless user experience , , platform and orientation
  {
    id: "03",
    title: "Responsive Design",
    desc: "Responsive Web design is the approach that suggests that design and development should respond to the user's behavior and environment based on screen size.",
  },
  {
    id: "04",
    title: "Bug Fixing",
    desc: "A bug fix is a change to a system or product designed to handle a programming bug/glitch. Many different types of programming bugs that create errors with system implementation.",
  },
  {
    id: "05",
    title: "Clean Code",
    img: '<i className="fa-solid fa-code"></i>',
    desc: "Clean code is at the core of my frontend development services. I prioritize writing code that is easy to understand, maintain, and extend. ",
  },
  {
    id: "06",
    title: "Awesome Support",
    desc: "I am dedicated to providing awesome support throughout every stage of your project. You can count on me for prompt .",
  },
];

const Services = () => {
  return (
    <div id="services" className="container" style={{ marginTop: "70px" }}>
      <div className="heading-section">
        <h4 className="mb-5">My Services</h4>
      </div>
      <div className="row">
        {services.slice(0, 4).map((service) => (
          <div key={service.id} className="col-md-3 col-12 mb-3">
            <div
              className="service "
              data-aos="flip-left"
              data-aos-easing="ease-out-cubic"
              data-aos-duration="2000"
            >
              <div className="service_con text-start mt-5 ">
                {/* <div className="service_icon">
                <img src={service.img} alt="" height={50} />
              </div> */}
                <h5>{service.title}</h5>
                <p>{service.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="d-flex justify-content-center align-items-center">
        <div className="row ">
          {services.slice(4, 7).map((service) => (
            <div key={service.id} className="col-md-3 col-12 mb-3 ">
              <div
                className="service "
                data-aos="flip-left"
                data-aos-easing="ease-out-cubic"
                data-aos-duration="2000"
              >
                <div className="service_con text-start mt-5 ">
                  {/* <div className="service_icon">
                <img src={service.img} alt="" height={50} />
              </div> */}
                  <h5>{service.title}</h5>
                  <p>{service.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
